import { $Q } from '../utils/querySelector';

(() => {
  const element = $Q('#js-infinite-scroll');

  if (element) {
    const observer = new MutationObserver((mutationList, obs) => {
      // from mutation list, grab the new nodes, but only the ones that have a classList
      // element (basically, the ones that are actual HTML elementes)
      const addedNodes = mutationList
        .map((mutation) => mutation.addedNodes)
        .map((node) => Array.from(node.values()))
        .flat()
        .filter((node) => node.classList);

      // check if there's any product card here
      const containsProductCards = addedNodes.some((node) =>
        node.classList.contains('product-card')
      );

      // then, if there's any product, reload necesary scripts
      if (containsProductCards) {
        // reload star badges so review stars appear on newly added products
        window.StampedFn.loadBadges();
        window.backInStockRegisterEvents();
      }
    });

    observer.observe(element, { childList: true, subtree: true });
  }
})();
